import { axiosGet } from '@/app/helpers/AxiosHelper';

export default {
    state: {
    },

    getters: {
    },

    mutations: {
    },

    actions: {
    }
}